export const CONTEXT_PATH = '/boliglaansoeknad-web';
export const SERVICE_PATH = 'rest/resource';
